import styled, { css } from 'styled-components'

import { Input } from '../../styles/defaults'
import { minmedia, maxmedia } from '../../styles/media-queries'
import { white, almostblack, bordergray } from '../../styles/colors'

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
  position: relative;
  z-index: 1;
  border-bottom: none;
  padding-bottom: 0;

  ${props => props.dark && css`
    border-bottom: 1px solid ${bordergray};
    padding-bottom: 2rem;

    ${minmedia.medium`
      padding-bottom: 1.5rem;
    `}
  `};
`

export const Title = styled.h3`
  transition: opacity 0.5s;
  color: ${props => (props.dark ? almostblack : white)};
  margin: 0;
  font-weight: 300;
  font-size: 16px;

  @media screen and (max-width: 374px) {
    font-size: 14px;
  }

  ${maxmedia.medium`
    margin-top: .75rem;
    opacity: ${props => (props.show === true ? '1' : '0')};
    max-width: 200px;
  `}
  ${minmedia.medium`
    font-size: 20px;
  `}
  ${minmedia.large`
    font-size: 24px;
  `};
`

export const InputContainer = styled.div`
  position: relative;

  ${maxmedia.medium`
    position: absolute;
    top: 0;
    right: 0;
  `};
`

export const IconContainer = styled.div`
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  width: 1.15rem;
  height: 1.15rem;

  svg {
    width: 1.15rem;
    height: 1.15rem;
    fill: ${props => (props.dark ? almostblack : white)};
  }
`

export const StyledInput = Input.extend`
  padding-left: 2.5rem;
  background: transparent;
  border-color: ${white};
  color: ${white};
  width: 140px;

  &:focus {
    width: 300px;
    border-color: ${white};
    box-shadow: 0;

    ${maxmedia.medium`
      width: calc(100vw - 4rem);
    `};
  }

  &::-webkit-input-placeholder {
    color: ${white};
  }
  &::-moz-placeholder {
    color: ${white};
  }
  &:-ms-input-placeholder {
    color: ${white};
  }

  // dark theme
  ${props => props.dark && css`
    border-color: ${almostblack};
    color: ${almostblack};

    &:focus {
      border-color: ${almostblack};

      ${maxmedia.medium`
        width: calc(100vw - 3rem);
      `};
    }

    &::-webkit-input-placeholder {
      color: ${almostblack};
    }
    &::-moz-placeholder {
      color: ${almostblack};
    }
    &:-ms-input-placeholder {
      color: ${almostblack};
    }
  `}
`



// WEBPACK FOOTER //
// ./src/components/BrancheHeader/styles.js